import React, { useEffect, useState } from 'react';
import '../../styles/PersonalTraining.css';
import banniere from '../../img/banniere.png';
import DashBoardNavBar from "../DashboardNavbar";
import firebase from "../../firebaseConfig";
import { useNavigate } from "react-router-dom";
import { FaInstagram, FaEnvelope } from 'react-icons/fa';

const PersonalTraining = ({user}) => {
    const [userName, setUserName] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Vérifier si l'utilisateur dispose d'un abonnement valide
        const checkPlanValidity = async () => {
            if (user) {
                const userId = user.uid;
                const docRef = firebase.firestore().collection('users').doc(userId);
                const docSnapshot = await docRef.get();
                if (docSnapshot.exists) {
                    const data = docSnapshot.data();
                    setUserName(data.username)
                }
            }else {
                // Utilisateur non connecté, gérer le cas approprié ici si nécessaire
                // Par exemple, rediriger vers la page de connexion
                navigate('/login');
            }
        };
        checkPlanValidity();
    }, []);

    return (
        <>
            <DashBoardNavBar userName={userName} boldItem={'personalTraining'}/>
            <div className="modern-container">
                <div className="hero-section">
                    <img src={banniere} alt="Personal Training Banner" className="hero-image" />
                    <div className="hero-overlay">
                        <h1>Transform Your Life with Personal Training</h1>
                        <p>Customized workouts, expert guidance, real results.</p>
                    </div>
                </div>
                
                <div className="content-section">
                    <h2>Ready to Take Your Fitness Journey to the Next Level?</h2>
                    <p className="lead-text">
                        Our personal training program is designed to help you achieve your specific fitness goals
                        through customized workout plans and expert guidance.
                    </p>
                    
                    <div className="benefits-grid">
                        <div className="benefit-card">
                            <h3>Personalized Plans</h3>
                            <p>Workouts tailored specifically to your goals, fitness level, and preferences.</p>
                        </div>
                        <div className="benefit-card">
                            <h3>Expert Guidance</h3>
                            <p>Work directly with certified trainers who are passionate about helping you succeed.</p>
                        </div>
                        <div className="benefit-card">
                            <h3>Accountability</h3>
                            <p>Stay motivated with regular check-ins and progress tracking.</p>
                        </div>
                        <div className="benefit-card">
                            <h3>Efficient Results</h3>
                            <p>Get more from every workout with proven techniques and proper form instruction.</p>
                        </div>
                    </div>
                    
                    <div className="cta-section">
                        <h2>Ready to Start?</h2>
                        <p>Contact us today to schedule your consultation and begin your transformation</p>
                        <div className="contact-buttons">
                            <a href="https://instagram.com" className="contact-button instagram" target="_blank" rel="noopener noreferrer"><FaInstagram /> Follow on Instagram</a>
                            <a href="mailto:contact@ofd.com" className="contact-button email"><FaEnvelope /> Email Us</a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PersonalTraining;
